import axios from '../axios'

/* 
 * 操作日志模块
 */

// 删除
export const del = (data) => {
    return axios({
        url: '/operateLog/del',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/operateLog/list',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/modules/log.js